module.exports = __webpack_public_path__ + "img/840.bee61ceb.png";